"use strict";
/**
 * 分页组件
 */
exports.__esModule = true;
var pagerbox = /** @class */ (function () {
    function class_1(opts) {
        var _this = this;
        this.pageshownum = 5;
        this.target = "";
        var defaults = {
            pagerid: '',
            currentpage: 1,
            pagesize: 0,
            allcount: 0,
            href: '',
            onClick: null
        };
        this.ops = $.extend(defaults, opts);
        if (!this.ops.pagerid) {
            if (!this.ops.dom)
                return;
            this.div = this.ops.dom;
        }
        else
            this.div = $('#' + this.ops.pagerid);
        var formhtml = $("<div class=\"gotopage\"><form target=\"_self\"><span class='tab'>\u8DF3\u8F6C\u5230</span><input class='ipt' type='text' id=\"gotopageindex\"><input type='submit' class='btn' value='\u786E\u5B9A'></form></div>");
        formhtml.on('submit', function name() {
            var gotopageindex = 1;
            var totalpage = _this.ops.totalPage || Math.ceil(_this.ops.allcount / _this.ops.pagesize);
            try {
                gotopageindex = parseInt($.trim($('#gotopageindex', formhtml).val().toString()));
            }
            catch (error) {
            }
            //如果超过最大页数
            if (totalpage < gotopageindex) {
                gotopageindex = totalpage;
            }
            if (gotopageindex < 1) {
                gotopageindex = 1;
            }
            _this.changePage(gotopageindex);
            return false;
        });
        this.div.html('').append('<div class="pagerbox"></div>').append(formhtml);
        this.bind();
        this.show();
    }
    ;
    class_1.prototype.changePage = function (curPage) {
        var _this = this;
        if (!!_this.ops.href) {
            // console.log(this.ops.href)       
            return false;
        }
        else if (this.ops.onClick) {
            _this.ops.onClick(curPage);
        }
    };
    ;
    class_1.prototype.show = function () {
        var _this = this;
        var pageshownum = _this.pageshownum;
        var totalPage = this.ops.totalPage || Math.ceil(this.ops.allcount / this.ops.pagesize);
        var currentpage = _this.ops.currentpage;
        var hrefStr = _this.ops.href ? _this.ops.href : 'javascript: ;';
        var target = _this.target ? _this.target : '_self';
        var leftStr = "";
        var rightStr = "";
        var allStr = "";
        if (pageshownum <= 0)
            pageshownum = 5;
        var LRNum = Math.ceil((pageshownum - 1) / 2);
        // var totalPage = this.totalPage;
        var Li = 0, Rj = 0;
        //需要展示的页数和当前页逻辑处理
        for (var i = LRNum; i >= 1; i--) {
            if (currentpage - i >= 1) {
                leftStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + (currentpage - i) + ">" + (currentpage - i) + "</a>";
                Li += 1;
            }
        }
        for (var j = 1; j <= LRNum; j++) {
            if (currentpage + j <= totalPage) {
                rightStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + (currentpage + j) + ">" + (currentpage + j) + "</a>";
                Rj += 1;
            }
        }
        //总页数小于/大于显示页数时处理
        if (totalPage < pageshownum)
            pageshownum = totalPage;
        if ((Li + Rj) < (pageshownum - 1)) {
            if (currentpage <= pageshownum / 2 + 1) {
                for (var j = currentpage + Rj + 1; j <= pageshownum; j++) {
                    rightStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + j + ">" + j + "</a>";
                }
            }
            else {
                for (var i = (currentpage - Li - 1); i > totalPage - pageshownum; i--) {
                    leftStr = "<a target=" + target + " href=" + hrefStr + " data-page=" + i + ">" + i + "</a>" + leftStr;
                }
            }
        }
        if (totalPage > pageshownum) {
            if (currentpage > (pageshownum + 1) / 2) {
                if (currentpage <= pageshownum) {
                    leftStr = "<a target=" + target + " href=" + hrefStr + " data-page='1'>1</a>" + "<a href=" + hrefStr + " target=" + target + "  data-page=" + 1 + ">...</a>" + leftStr;
                }
                else {
                    leftStr = "<a target=" + target + " href=" + hrefStr + " data-page='1'>1</a>" + "<a href=" + hrefStr + " target=" + target + "  data-page=" + (currentpage - 5) + ">...</a>" + leftStr;
                }
                // leftStr = "<a target=" + target + " href=" + hrefStr + " data-page='1'>1</a>" + "<a href=" + hrefStr + " target=" + target + "  data-page=" + (currentpage -5) +">...</a>" + leftStr;
            }
            if (currentpage <= totalPage - (pageshownum + 1) / 2) {
                if ((totalPage - currentpage) < pageshownum) {
                    rightStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + (totalPage) + ">...</a>" + "<a href=" + hrefStr + " target=" + target + " data-page=" + totalPage + ">" + totalPage + "</a>";
                }
                else {
                    rightStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + (currentpage + 5) + ">...</a>" + "<a href=" + hrefStr + " target=" + target + " data-page=" + totalPage + ">" + totalPage + "</a>";
                }
                //rightStr += "<a target=" + target + " href=" + hrefStr + " data-page=" + (currentpage+5)+">...</a>" + "<a href=" + hrefStr + " target=" + target + " data-page=" + totalPage+">" + totalPage + "</a>";
            }
        }
        //上一页
        var prevPage = "";
        var pre = currentpage - 1;
        if (pre < 1) {
            pre = 1;
        }
        prevPage = _this.ops.href ? _this.ops.href : 'javascript: ;';
        if (pre == 1) {
            //prevPage = '';
        }
        else {
            // prevPage = "_" + pre;
            // if (!!this.ops.href) {
            //     prevPage = "" + pre;
            // }
        }
        //下一页
        var nextPage = "";
        var next = currentpage + 1;
        if (next > totalPage) {
            next = totalPage;
        }
        nextPage = _this.ops.href ? _this.ops.href : 'javascript: ;';
        if (next == 1) {
            //nextPage = '';
        }
        else {
            // nextPage = "_" + next;
            // if (!!this.ops.href) { 
            //     nextPage = "" + next;
            // }
        }
        //上一页下一页及指定页数跳转
        if (currentpage > 1) {
            allStr = "<a target=" + target + " href=" + prevPage + " data-page=" + pre + ">上一页</a> ";
        }
        allStr += leftStr + "<a class='active' data-page=" + currentpage + ">" + currentpage + "</a>" + rightStr;
        if (currentpage < totalPage) {
            allStr += " <a target=" + target + " href=" + nextPage + " data-page=" + next + ">下一页</a>";
        }
        $('.pagerbox', this.div).empty().append(allStr);
        $('#gotopageindex', this.div).val(currentpage);
    };
    class_1.prototype.bind = function () {
        var _this = this;
        this.div.off('click').on('click', 'a', function () {
            var curPage = $(this).data('page');
            _this.changePage(curPage);
        });
    };
    return class_1;
}());
exports["default"] = pagerbox;
